













































































































import { Component, Watch } from 'vue-property-decorator';
import { HeaderList } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import { treatValue } from '@/utils/moneyTreatments';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import TransactionsService from '@/api/TransactionsService';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';

@Component({
  components: {
    FlexButton,
    RowsTable,
    CustomSelect,
    TextInput,
    SideModalHeader,
    ContentContainer,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    TableCard,
    Typography
  }
})
export default class OfferActivities extends BasePagination {
  pageName = 'Transactions';
  subTitle = 'Coupon Activities';
  labelInputFilter = 'Search by offer title';
  searchableFields = 'searchableFields=offer.title';
  sortField = 'coupon.createdAt';
  sortOrder = 'DESC';
  service: TransactionsService = new TransactionsService();

  @Watch('isLoading')
  showFullLoadingOnMobile() {
    if (this.isMobileDevice && this.isLoading) {
      this.$showLoaderWithLocker();

      return;
    }

    this.$hideLoader();
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  async reloadList(clearList?: boolean, refreshCurrent?: boolean) {
    if (clearList) {
      this.resetPagination();
      this.dataList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.isLoading = true;
    this.refreshing = true;

    const paginationQuery = new URLSearchParams(this.pagination);

    const paginationQueryParameter = paginationQuery.toString() + '&';

    try {
      const response = await this.service.getCoupons(
        this.sortField,
        this.sortOrder,
        paginationQueryParameter,
        this.query
      );

      const { data } = response;
      const { items, links } = data;

      const nextLink = `${links.next}&`;

      if (refreshCurrent) {
        // refresh page and reinitilize pagination
        this.resetPagination();
        this.pagination = nextLink;
        if (!links.next) this.maxItems = true;
        this.dataList.list = this.addRowsToList(items);

        return;
      }

      // refresh page and add items
      this.dataList.list = this.dataList.list.concat(this.addRowsToList(items));
      if (!links.next) this.maxItems = true;
      this.pagination = nextLink;
    } finally {
      this.isLoading = false;
      this.refreshing = false;
    }
  }

  //basic functions to initi base page
  initFilterModel() {
    const typeGroup = new CustomSelectGroup(
      [
        new CustomSelectOption('general', 'General'),
        new CustomSelectOption('birthday', 'Birthday')
      ],
      'Filter offer by type'
    );

    const statusGroup = new CustomSelectGroup(
      [
        new CustomSelectOption('active', `Active`),
        new CustomSelectOption('redeemed', `Redeemed`),
        new CustomSelectOption('deleted', `Deleted`)
      ],
      'Filter offer by status'
    );

    this.filterModel = new CustomSelectModel(
      [typeGroup, statusGroup],
      `Filter offer by`,
      false,
      true,
      true,
      false
    );
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  // TODO ADD TYPES
  addRowsToList(rows = []) {
    const formatedRows = rows.map((row: any) => ({
      title: row.offer.title || '-',
      type: row.offer.type || '-',
      couponCode: row.coupon.code || '-',
      customerName: `${row.customer.name || '-'} ${row.customer.lastname ||
        ''}`,
      created: DateUtils.formatISODate(row.coupon.createdAt),
      status: this.helper.capitalize(
        row.coupon.status == 'available' ? 'Saved' : row.coupon.status
      )
    }));

    return formatedRows;
  }

  detail(transaction: any) {
    if (transaction.birthday) {
      const customer = transaction;
      const data = {
        name: `${customer.name} ${customer.lastname}`,
        spent: `$${treatValue(customer.totalSpent) || '0'}`,
        reward: treatValue(customer.totalRewards) || '0',
        coins: treatValue(customer.totalCoins) || '0',
        visits: customer.totalVisits || '0',
        id: customer.id,
        lastSeen: DateUtils.formatISODate(customer.lastSeen)
      };
      const modalConfig = {
        isOpen: true,
        component: 'customerDetails',
        data
      };
      eventBus.$emit('setSideModalVisible', modalConfig);
      return;
    }

    const modalConfig = {
      isOpen: true,
      component: 'offersDetails',
      data: transaction
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  initHeader() {
    this.dataList.header.push(new HeaderList(`Offer title`, 'offer.title'));
    this.dataList.header.push(new HeaderList(`Offer Type`, 'offer.type'));
    this.dataList.header.push(new HeaderList(`Customer name`, 'customer.name'));
    this.dataList.header.push(new HeaderList(`Coupon Code`, 'coupon.code'));
    this.dataList.header.push(new HeaderList(`Date`, 'coupon.createdAt'));
    this.dataList.header.push(new HeaderList(`Action`, 'coupon.status'));
  }
}
